/**
 * Mask sensitive employee fields until the user chooses to reveal them.
 */

export function maskEmail(val) {
  const s = String(val || "").trim();
  if (!s) return "—";
  const at = s.indexOf("@");
  if (at <= 0) return "••••••••";
  const local = s.slice(0, at);
  const domain = s.slice(at + 1);
  const maskedLocal =
    local.length <= 1 ? "•" : `${local.slice(0, 1)}${"•".repeat(Math.min(6, Math.max(4, local.length)))}`;
  const domParts = domain.split(".");
  const tld = domParts.length > 1 ? domParts.pop() : "";
  const domName = domParts.join(".") || domain;
  const maskedDom =
    domName.length <= 1
      ? "•••"
      : `${domName.slice(0, 1)}${"•".repeat(Math.min(5, domName.length))}`;
  return tld ? `${maskedLocal}@${maskedDom}.${tld}` : `${maskedLocal}@${maskedDom}`;
}

export function maskPhone(val) {
  const raw = String(val || "").trim();
  if (!raw) return "—";
  const digits = raw.replace(/\D/g, "");
  if (!digits) return "••••••••";
  const tail = digits.slice(-2);
  return `${"•".repeat(Math.min(10, digits.length))}${tail}`;
}

/** Pay group, employment type, etc. — no readable hint when masked */
export function maskPlain(val) {
  const s = String(val || "").trim();
  if (!s) return "—";
  return "••••••••";
}

/** National ID: show only last few digits (no full number when hidden). */
export function maskNationalId(val) {
  const raw = String(val || "").trim();
  if (!raw) return "—";
  const digits = raw.replace(/\D/g, "");
  if (digits.length < 2) return "••••••••";
  const tail = digits.slice(-2);
  return `${"•".repeat(Math.min(10, Math.max(4, digits.length - 2)))}${tail}`;
}

/** Date of birth: do not show day/month/year when hidden. */
export function maskDateOfBirth(val) {
  if (val == null || val === "") return "—";
  return "••/••/••••";
}
